import { Component, OnInit, ViewChild } from '@angular/core';
import { DatatableBaseComponent } from '@components/datatable-base.component';
import { trigger, state, style } from '@angular/animations';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { UiService } from '@services/ui.service';
import { ProductType } from '@classes/productType';
import { ProductTypesService } from '@services/productTypes.service';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-product-types',
  templateUrl: './product-types.component.html',
  styleUrls: ['./product-types.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' }))
    ])
  ]
})
export class ProductTypesComponent extends DatatableBaseComponent implements OnInit {
  productTypes: ProductType[];

  displayedColumns = ['name', 'client', 'minimum', 'maximum', 'actions'];
  dataSource: MatTableDataSource<ProductType>;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    protected uiSrv: UiService,
    private route: ActivatedRoute,
    private productTypesSrv: ProductTypesService
  ) {
    super(uiSrv);
  }

  ngOnInit() {
    super.ngOnInit();
    this.getRouteData();
    this.initSubscriptions();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  private initTable(): void {
    this.dataSource = new MatTableDataSource(this.productTypes);
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'client': return item.client.name;
        default: return item[property];
      }
    };

    this.dataSource.filterPredicate = (data, filter: string) => {
      const accumulator = (currentTerm, key) => {
        switch (key) {
          case 'client': return currentTerm + data.client.name;
          default: return currentTerm + data[key];
        }
      };
      const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
      // Transform the filter by converting it to lowercase and removing whitespace.
      const transformedFilter = filter.trim().toLowerCase();
      return dataStr.indexOf(transformedFilter) !== -1;
    };
    this.dataSource.sort = this.sort;
  }

  private getRouteData(): void {
    this.route.data
      .subscribe((data: { productTypes: ProductType[] }) => {
        this.productTypes = data.productTypes;
        this.initTable();
      });
  }

  private initSubscriptions(): void {
    this.addSubscription(
      this.productTypesSrv.productTypesListChanged
        .subscribe(productTypes => {
          this.dataSource.data = productTypes || [];
          this.dataSource.sort = this.sort;
          this.onEditFinished();
        })
    );
  }

  delete(idProductType: string) {
    const confirmation = confirm('Êtes-vous certain de vouloir supprimer ce Température de transport ?');

    if (confirmation) {
      this.productTypesSrv.delete(idProductType).subscribe(() => {
        this.uiSrv.showSnackbar('repository.productTypes.deleted', true);
      });
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
